<template>
    <v-dialog v-model="printerMapDialog" scrollable persistent max-width="700">
        <v-card>
          <v-card-title>
            <span class="headline">Mapping delle Stampanti</span>
          </v-card-title>
          <v-card-text>
            <v-form>
                <v-container grid-list>
                        <v-layout wrap>
                            <v-flex xs6>
                                <h3>Crea Relazione</h3>
                                <v-form>
                                    <v-select
                                        ref="primarySelect"
                                        label="Stampante di Entrata"
                                        :items="primaryPrinters"
                                        v-model="printerRelationship.from"                                    
                                        item-value="name"
                                        item-text="name"
                                        @change="removeSelectedPrinterFromSecondarySelect"
                                        v-validate="'required'"
                                        data-vv-name="from"
                                        data-vv-scope="printerMapForm"
                                        :error-messages="errors.first('printerMapForm.from')"
                                        required
                                    ></v-select>
                                    <v-select
                                        v-if="this.printerRelationship.from"
                                        ref="secondarySelect"
                                        label="Stampante di Uscita"
                                        :items="secondaryPrinters"
                                        v-model="printerRelationship.to"
                                        item-value="name"
                                        item-text="name"
                                        v-validate="'required'"
                                        data-vv-name="to"
                                        data-vv-scope="printerMapForm"
                                        :error-messages="errors.first('printerMapForm.to')"
                                        required
                                    ></v-select>
                                 <v-btn block info @click="addRelationship()">Aggiungi Relazione</v-btn>
                                </v-form>
                                
                            </v-flex>
                            <v-flex xs6 >
                                <h3>Lista Relazioni</h3>
                                <v-list dense class="printerlist--fixed-height">
                                    <template v-for="(item, index) in mappedRelationshipArray">
                                        <v-list-tile
                                            :key="index"
                                        >                         
                                            <v-list-tile-title >Da: {{item.from}} A: {{item.to}}</v-list-tile-title>  
                                            <v-list-tile-action>
                                                <v-icon @click="deleteMappedRelationship(index)">close</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                    </template>
                                </v-list>
                            </v-flex>
                        </v-layout>
                    </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error darken-1" flat @click="closePrinterMapDialog()">Annulla</v-btn>
            <v-btn color="success darken-1" flat @click="savePrintersMap()">Salva</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
</template>
<script>
import uuidv4 from "uuid/v4";
export default {
    name: 'printerMapDialog',
    props:[
        'printerMapDialog', 'printersMap', 'printers'
    ],
    data() {
        return {
            printerRelationship: {
                from: '',
                to: ''
            },
            printersAuxArray: [...this.printers],
            primaryAuxPrinters: [...this.printers],
            secondaryAuxPrinters: [...this.printers],
        }
    },
    computed: {
        mappedRelationshipArray() {
            return this.printersMap ? this.printersMap : [];
        },
        primaryPrinters() {
            if (this.printersMap.length !== 0) {
                this.printersMap.forEach(element => {
                    this.primaryAuxPrinters.forEach((printerElement, index) => {
                        if (printerElement.name === element.from) {
                            this.primaryAuxPrinters.splice(index, 1);
                        }
                    });
                });
            } else {
                this.primaryAuxPrinters = [...this.printersAuxArray];
            }
            return this.primaryAuxPrinters;
        },
        secondaryPrinters: {
            get(){
                if (this.printersMap.length !== 0) {
                    this.printersMap.forEach(element => {
                        this.secondaryAuxPrinters.forEach((printerElement, index) => {
                            if (printerElement.name === element.from) {
                                this.secondaryAuxPrinters.splice(index, 1);
                            }
                        });
                    });
                } else {
                    this.secondaryAuxPrinters = [...this.printersAuxArray];
                }
                return this.secondaryAuxPrinters;
            },
            set(value){
                this.secondaryAuxPrinters = value;
            }            
        }
    },
    methods: {    
        removeSelectedPrinterFromSecondarySelect(changeValue){
            // removes the printer from the select field so the user cannot select the same printer on the secondary select
            let auxArray =  [...this.primaryPrinters];
            if (changeValue) {
                auxArray.forEach((element, index) => {
                    if (element.name === changeValue) {
                    auxArray.splice(index,1)
                    }
                });
            }
            this.secondaryPrinters = auxArray;
        },    
        removePrinterFromProcess(printer){
            // removes the primary printer from the selection on both printers
            if (printer) {
                this.secondaryPrinters.forEach((element, index) => {
                    if (element.name === printer) {
                    this.secondaryPrinters.splice(index,1)
                    }
                });
                this.primaryPrinters.forEach((element, index) => {
                    if (element.name === printer) {
                    this.primaryPrinters.splice(index,1)
                    }
                });
            }
        },
        addRelationship() {
            this.$validator.validate("printerMapForm.*").then((result) => {
                if (result) {                    
                    this.mappedRelationshipArray.push(utils.clone(this.printerRelationship));
                    this.removePrinterFromProcess(this.printerRelationship.from);
                    this.$validator.reset();
                    this.printerRelationship.from = '';
                    this.printerRelationship.to = '';
                }
            });            
        },
        deleteMappedRelationship(index) {
            let deletedElement = this.mappedRelationshipArray[index].from;
            let printerData = this.printersAuxArray.find(element => element.name == deletedElement);
            this.primaryPrinters.push(printerData)
            this.secondaryPrinters.push(printerData)
            this.mappedRelationshipArray.splice(index, 1);
        },
        savePrintersMap() {
            this.$validator.reset();
            this.$emit('closeDialog', this.mappedRelationshipArray);            
            this.printerRelationship.from = '';
            this.printerRelationship.to = '';
        },
        closePrinterMapDialog() {
            this.$validator.reset();
            this.$emit('closeDialog');
            this.printerRelationship.from = '';
            this.printerRelationship.to = '';
        },        
    }
}
</script>

<style lang="stylus">
.printerlist--fixed-height
    height: 300px;
    overflow-y: auto;
</style>


// WEBPACK FOOTER //
// src/components/common/PrinterMapDialog.vue